import { useIntl } from 'react-intl';

import {
    LocalHeroBadge as LocalHeroBadgeDesignSystem,
    LocalHeroBadgeProps,
} from '../../../../design-system/components/local-hero/LocalHeroBadge';

export function LocalHeroBadge(props: LocalHeroBadgeProps) {
    const { formatMessage } = useIntl();

    return (
        <LocalHeroBadgeDesignSystem {...props}>
            {formatMessage({ id: 'global.component.localHeroBadge.content' })}
        </LocalHeroBadgeDesignSystem>
    );
}
